<template>
  <div class="smart-point-widget-selection">
    <div v-if="!getIsSmartPointOnlyTransporter" class="smart_point-selection-pickup-home">
      <label for="pickUpHome">
        <input
          id="pickUpHome"
          class="smart_point-selection-pickup-home-label"
          type="radio"
          v-on:click="smartPointUncheck"
          :checked="!getSmartPointIsSelected"
        >
        {{ t('preview.order.smartpoints.pickup.at.home') }}
      </label>
    </div>
    <div v-show="getIsSmartPointAllOptionsTransporter" class="smart_point-selection-pickup-point">
      <label for="pickUpPoint" class="smart_point-selection-pickup-point-label">
        <input
          name="smartPointChecked"
          ref="pickUpPoint"
          type="radio"
          id="pickUpPoint"
          :value="getSmartPointIsSelected ? 1 : 0"
          :checked="getSmartPointIsSelected"
          v-on:click="smartPointClickEvent()"
        >
        {{ t('preview.order.smartpoints.pickup', { params: [{ transporterName: getSelectedTransporterClassName }] }) }}
      </label>
      <div class="smart_point-tooltip">
        <i class="lni lni-question-circle"></i>
        <span class="smart_point-tooltip-text" v-html="t('preview.order.smartpoints.tooltip', {params: [{transporterName: getSelectedTransporterClassName}]})"></span>
      </div>
    </div>
    <div v-if="shouldDisplaySmartPointSelectionError"
         class="smart-point-selected error">
      <span class="smart-point-selected-text-error">{{ t('preview.order.smartpoints.error.msg') }}</span>
    </div>
    <div
      v-if="getSelectedSmartPoint && (shouldEnableSmartPointSelection(transporter.class_name) || shouldEnableSmartPointSelectionWidget(transporter.class_name))"
      class="smart-point-selected"
    >
      <span class="smart-point-selected-text" @click="smartPointClickEvent()">
        {{ t('checkout.transporters.smart_point.selected.locker') }}
        <span class="smart-point-selected-text-point_name">
          {{ getSelectedSmartPoint.name }}
        </span>
      </span>
    </div>
  </div>
</template>

<script>
import SmartPointMixin from '../SmartPointMixin'

export default {
  name: 'SmartPointWidgetSelection',
  mixins: [SmartPointMixin],
  props: {
    transporter: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.smart_point-tooltip {
  position: relative;
  display: inline-block;
  &:hover {
    cursor: pointer;
    i {
      font-weight: 700;
    }
    .smart_point-tooltip-text {
      visibility: visible;
    }
  }
  &-text {
    visibility: hidden;
    width: 200px;
    font-size: 12px;
    background-color: black;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;
    bottom: 15px;
    position: absolute;
    z-index: 1;
    @media screen and (max-width: 767px) {
      right: 0;
    }
  }
}
.smart_point-response-error {
  font-size: 12px;
  color: red;
}
.smart_point-selection-pickup-point-label, .smart_point-selection-pickup-home-label {
  &:hover {
    cursor: pointer;
  }
}
.smart_point-selection-pickup-point {
  @media screen and (max-width: 767px) {
    display: grid;
    grid-template-columns: auto 1fr;
    align-items: center;
    justify-items: center;
  }
}
</style>
